<template>
    <div>
        <div v-if="row.task_status == 0">导入中…</div>
        <div v-else>
            <span>成功<span class="ml-4 success">{{ row.success_count }}</span></span>
            <span class="ml-24" v-if="row.task_status != 1">失败<span class="ml-4 error">{{ row.fail_count
                    }}</span></span>
        </div>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
    mixins: [mixin],
    data() {
        return {};
    },
    computed: {},
    components: {},
};
</script>
<style lang="less" scoped>
.success {
    color: @color-g;
}

.error {
    color: @color-r;
}
</style>
